import React, { createContext, useContext, useState } from 'react';

// Generiert einen Standard-Plannamen
const generateDefaultPlanName = () => {
  return 'unbenannt';
};

// Context für Plan-Metadaten (Name, Version, etc.)
const PlanMetadataContext = createContext();

export const PlanMetadataProvider = ({ children }) => {
  // Initialisiere sofort mit Standard-Werten
  const defaultName = generateDefaultPlanName();
  const [planMetadata, setPlanMetadata] = useState({
    planName: defaultName,
    planVersion: 1,
    planId: null,
    baseName: defaultName
  });

  const updatePlanMetadata = (metadata) => {
    setPlanMetadata(prevMetadata => {
      const newMetadata = {
        ...prevMetadata,
        ...metadata
      };
      return newMetadata;
    });
  };

  const clearPlanMetadata = () => {
    setPlanMetadata({
      planName: null,
      planVersion: 1,
      planId: null,
      baseName: null
    });
  };

  return (
    <PlanMetadataContext.Provider value={{
      planMetadata,
      updatePlanMetadata,
      clearPlanMetadata
    }}>
      {children}
    </PlanMetadataContext.Provider>
  );
};

export const usePlanMetadata = () => {
  const context = useContext(PlanMetadataContext);
  if (!context) {
    throw new Error('usePlanMetadata must be used within a PlanMetadataProvider');
  }
  return context;
};